<template>
  <div :class="$style.root">
    <div :class="$style.tabContainer">
      <Link
        v-for="(tab, n) in tabs"
        :to="tab.to"
        :class="$style.tab"
        :key="tab.label"
        @mouseenter.native="handleCursorIn(n)"
        @mouseleave.native="handleCursorOut(n)"
      >
        <SvgIcon :svg="tab.icon" />
        <div>{{ tab.label }}</div>
      </Link>
      <Link
        :class="$style.tab"
        to="#"
        @mouseenter.native="handleCursorIn(tabs.length)"
        @mouseleave.native="handleCursorOut(tabs.length)"
        @click.native="handleLogout"
      >
        <SvgIcon :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/logout-variant.svg')" />
        <div>登出</div>
      </Link>
      <div :class="$style.indicator" :style="indicatorStyle"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SvgIcon from './SvgIcon'
import Link from './Link'

export default {
  components: {
    SvgIcon,
    Link,
  },
  data () {
    return {
      hover: -1,
    }
  },
  computed: {
    active () {
      if (this.hover > -1) {
        return this.hover
      }
      const index = this.tabs.slice(1).findIndex((tab) => {
        return this.$route.path.includes(tab.to)
      })
      return Math.max(0, index + 1)
    },
    indicatorStyle () {
      const top = this.active * 96
      return {
        'margin-top': `${top}px`
      }
    },
    ...mapGetters([
      'tabs',
    ]),
  },
  methods: {
    handleCursorIn (n) {
      this.hover = n
    },
    handleCursorOut (n) {
      this.hover = -1
    },
    async handleLogout () {
      this.$toasted.show('確定登出?', {
        action: [
          {
            text: '登出',
            onClick: async (e, toasted) => {
              try {
                await this.logout()
              } catch (e) {
                //
              } finally {
                toasted.goAway(0)
              }
            },
          },
          {
            text: '取消',
            onClick: (e, toasted) => {
              toasted.goAway(0)
            },
          },
        ],
      })
    },
    ...mapActions('auth', {
      logout: 'logout',
    }),
  },
}
</script>

<style lang="scss" module>
$color: #d27223;
$color-hover: darken($color, 10%);

.root {
  @apply absolute;
  @apply inset-y-0;
  @apply left-0;
  @apply flex;
  z-index: 1500;
  box-shadow: 0 0 3px 2px #00000014;
}

.tabContainer {
  @apply flex;
  @apply flex-col;
  @apply relative;
}

.tab {
  @apply py-4;
  @apply text-center;
  color: $color;
  transition: all .2s;
  @apply font-bold;
  width: 104px;
  @apply flex;
  @apply flex-col;
  @apply items-center;

  &:active {
    transform: scale(0.90);
  }

  &:hover {
    color: $color-hover;
  }
}

.indicator {
  @apply absolute;
  margin-left: 1px;
  height: 96px;
  width: 8px;
  background-color: $color;
  transition: .3s ease-in-out;
}
</style>
